import gsap from 'gsap'

class FlyoutAnimations {
  constructor(flyout) {
    this.flyout = flyout
  }

  static createAnimation(flyout) {
    const tl = gsap.timeline({
      onReverseComplete: () => {
        flyout.css('display', '')
      },
    })
    // Stop the timeline
    tl.pause()
    // animate the flyout container
    tl.from(flyout, {
      duration: 0.175,
      yPercent: -5,
      opacity: 0,
      ease: 'sine.inOut',
    })

    return tl
  }
}

export default FlyoutAnimations
